import Modal from 'LuxKit/Modal/Modal'
import VillasPageAmenitiesModalContent from 'components/OfferPage/Villas/VillasPageAmenitiesModalContent'
import ModalContext from 'contexts/ModalContext'
import { EmptyArray } from 'lib/array/arrayUtils'
import { getHotelOfferUrl } from 'lib/offer/offerPageURL'
import { useCallback, useContext } from 'react'
import { useIntl } from 'react-intl'
import SearchTileStackAmenitiesList from '../shared/SearchTileStackAmenitiesList'
import LoyaltyInclusions from 'loyalty/components/LoyaltyInclusions'

interface Props {
  offer: App.VillaOffer | App.VillaOfferSummary
  pkg?: App.HotelPackage
}

function VillaSearchTileFeatures({ offer, pkg }: Props) {
  const intl = useIntl()
  const VIPServices = pkg?.inclusions?.map((inclusion): App.PackageRoomAmenity => {
    return {
      id: inclusion.id,
      description: inclusion.description,
      group: 'VIP services',
    }
  }) ?? []
  const amenities = VIPServices.concat(pkg?.roomType.amenities ?? EmptyArray)

  const showModal = useContext(ModalContext)
  const openAmenitiesModal = useCallback(() => {
    showModal(
      <Modal
        title={offer.property.name}
        primaryActionTo={getHotelOfferUrl(offer.id, offer.type)}
        primaryActionText={intl.formatMessage({
          id: 'dlywzFwMOEUxbPfSbsSp',
          defaultMessage: 'View offer',
          description: 'CTA button in villa amenities modal to view the offer',
        })}
      >
        <VillasPageAmenitiesModalContent amenities={amenities} />
      </Modal>,
    )
  }, [showModal, offer, amenities, intl])

  if (!amenities.length) return null

  return <>
    <SearchTileStackAmenitiesList
      amenities={amenities}
      onMoreClick={openAmenitiesModal}
    />
    <LoyaltyInclusions offer={offer} variant="search-tile" />
  </>
}

export default VillaSearchTileFeatures
